import { Link } from "react-router-dom";
import { CheckCircle2, MessageCircle, Home, Heart } from "lucide-react";
import { useConfig } from "@/hooks/useConfig";

export default function Obrigado() {
  const cfg = useConfig();
  return (
    <main
      data-testid="obrigado-page"
      className="min-h-[100svh] bg-ga-ink text-white flex flex-col"
    >
      <div className="absolute inset-0 opacity-20 pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(at 20% 20%, #10B981 0%, transparent 50%), radial-gradient(at 80% 80%, #F59E0B 0%, transparent 50%)",
        }}
      />
      <div className="relative flex-1 container-ga flex flex-col justify-center py-20">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-ga-emerald/20 border border-ga-emerald/40 text-ga-emerald text-xs font-bold uppercase tracking-[0.2em] mb-8" data-testid="obrigado-badge">
            <CheckCircle2 className="w-4 h-4" />
            Doação recebida
          </div>

          <h1 className="font-display font-black tracking-tighter text-5xl sm:text-6xl lg:text-7xl leading-[0.98]">
            Muito obrigado <br />
            <span className="text-ga-amber">de coração</span>.
          </h1>

          <p className="mt-8 text-white/85 text-lg sm:text-xl leading-relaxed max-w-xl">
            Sua doação garante a continuidade do cuidado com famílias que dependem
            que chega a famílias, crianças e vidas inteiras todos os dias.
            Deus abençoe você por caminhar conosco.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            {cfg.whatsapp_url && (
              <a
                href={cfg.whatsapp_url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="obrigado-whatsapp"
                className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white font-bold py-3.5 px-7 hover:bg-[#1fb458] transition-colors shadow-xl"
              >
                <MessageCircle className="w-5 h-5" />
                Falar no WhatsApp
              </a>
            )}
            <Link
              to="/"
              data-testid="obrigado-home"
              className="inline-flex items-center gap-2 rounded-full border-2 border-white/20 text-white font-bold py-3.5 px-7 hover:bg-white hover:text-ga-ink transition-colors"
            >
              <Home className="w-5 h-5" />
              Voltar ao início
            </Link>
          </div>

          <div className="mt-14 rounded-3xl border border-white/10 bg-white/[0.03] p-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-2xl bg-ga-amber/20 flex items-center justify-center shrink-0">
                <Heart className="w-5 h-5 text-ga-amber" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-white/50 font-bold">
                  Quer multiplicar seu impacto?
                </div>
                <p className="text-white/85 mt-2">
                  Convide uma pessoa próxima para também apoiar a missão. Cada
                  nova doação permite que outra criança seja acolhida,
                  atendida e amada.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
